export const waitForImageLoad = async (img: HTMLImageElement, decode = false) => {
  if (img.complete) return true;
  if (!img.loading) return false;
  return new Promise((resolve, reject) => {
    img.onload = () => {
      if (!decode) resolve(true);
      else {
        if (img.decode) img.decode().then(resolve);
        else resolve(img);
      }
    };
    img.onerror = reject;
  });
};
